// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".send-customer-select .el-select-dropdown__item{padding:4px 20px;height:auto;display:flex;align-items:center;justify-content:space-between}.send-customer-select .el-select-dropdown__item .left-text{margin:2px 16px 0 0;max-width:280px;line-height:1.4;box-sizing:border-box;white-space:normal;word-break:break-all}", ""]);
// Exports
module.exports = exports;
